import app_2 from '@/public/features/mobile_app/App.webp';
import bg from '@/public/features/mobile_app/Frame 1171279341.webp';

const intro = {
  tag: '',
  description: `Enhance your business operations by using our mobile app to access everything you need from anywhere. Perfect for field workers, our app ensures you stay informed and efficient no matter where you are.`,
  imageSrc: bg.src,
  image: bg,
  first_title: 'Stay connected and manage\xa0your\xa0business on',
  second_title: ' the\xa0go\xa0with\xa0our\xa0Mobile App',
};

const blog = {
  title: 'Our Blog',
  description: `Dive into a wealth of insights tailored to your industry with Orcatec's blog, your go-to resource 
for the latest trends and tips in service scheduling software free`,
};

const bookDemo = {
  title: `Book a Free Demo`,
  description: `Book a free demo to unlock the full potential of our software for HVAC contractors! Orcatec team is here to guide you. Fill out the form below to receive expert consultation. Don’t miss this opportunity to transform your HVAC business with Orcatec's cutting-edge solutions, specially designed for HVAC contractors!`,
};

const fullArticle2 = {
  image: {
    path: app_2,
    alt: `What is a Mobile App?`,
  },
  title: `What is a Mobile App?`,
  description: `A mobile app is an essential tool for field workers, giving you access to your business operations from anywhere. This ensures you can manage tasks, communicate with clients, and stay updated on the go.`,
  item: [
    {
      title: 'Access everything, everywhere',
      description: `Ideal for field workers, our mobile app provides access to all your business operations no matter where you are, keeping you productive in the field.`,
    },
    {
      title: 'Push notifications',
      description: `Stay updated with real-time push notifications that inform you of any changes, updates, or important alerts, keeping you always in the loop.`,
    },
    {
      title: 'Client interaction',
      description: `Let clients view invoices, sign documents, and make payments right at the job site, streamlining the entire process.`,
    },
    {
      title: 'Cross-platform compatibility',
      description: `Our mobile app is designed for both Android and iOS, and works seamlessly on phones and tablets, ensuring it meets all your needs no matter what device you use.`,
    },
  ],
};

export { blog, bookDemo, fullArticle2, intro };
